// src/services/api.js

const BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://api.swansandbox.com'
  : '';

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || response.statusText);
  }
  return response.json();
};

export const api = {
  // Stories endpoints
  getStories: async () => {
    const response = await fetch(`${BASE_URL}/api/stories`);
    return handleResponse(response);
  },

  saveStory: async (story) => {
    const response = await fetch(`${BASE_URL}/api/stories`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(story)
    });
    return handleResponse(response);
  },

  updateStory: async (timestamp, updates) => {
    const response = await fetch(`${BASE_URL}/api/stories/${timestamp}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates)
    });
    return handleResponse(response);
  },

  // Scenarios endpoints
  getScenarios: async () => {
    const response = await fetch(`${BASE_URL}/api/scenarios`);
    return handleResponse(response);
  },

  saveScenario: async (scenario) => {
    const response = await fetch(`${BASE_URL}/api/scenarios`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(scenario)
    });
    return handleResponse(response);
  },

  // Search history endpoints
  getSearchHistory: async () => {
    const response = await fetch(`${BASE_URL}/api/search-history`);
    return handleResponse(response);
  },

  saveSearchHistory: async (searchData) => {
    const response = await fetch(`${BASE_URL}/api/search-history`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(searchData)
    });
    return handleResponse(response);
  }
};

export default api;